module.exports = __webpack_public_path__ + "img/openai.20abca60.svg";